import { ScreenTrigger, ScreenType } from '@frontend/wizard/types';

import { useWizardBasketItems } from '../../hooks/useWizardBasketItems';
import { useScreen } from '../useScreen';

export const useBasketOverview = () => {
    const { basketItems, updateBasketItem } = useWizardBasketItems();
    const { onBack, onSubmit, store } = useScreen();

    const continueToDeliveryLocation = () => {
        onSubmit(store?.steps.find((step) => step.screen === ScreenType.BASKET_OVERVIEW && step.trigger === ScreenTrigger.SUBMIT));
    };

    return { basketItems, updateBasketItem, onBack, continueToDeliveryLocation };
};
